"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBubbleChartSeries = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var common_1 = require("../_util/common");
var last_1 = tslib_1.__importDefault(require("lodash/last"));
function getCountOfEmptyBuckets(bucketEmptyFlags) {
    if (bucketEmptyFlags === void 0) { bucketEmptyFlags = []; }
    return bucketEmptyFlags.filter(function (bucketEmpyFlag) { return bucketEmpyFlag; }).length;
}
function getBubbleChartSeries(dv, measureGroup, 
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
stackByAttribute, colorStrategy) {
    var primaryMeasuresBucketEmpty = dv.def().isBucketEmpty(sdk_ui_1.BucketNames.MEASURES);
    var secondaryMeasuresBucketEmpty = dv.def().isBucketEmpty(sdk_ui_1.BucketNames.SECONDARY_MEASURES);
    var legendIndex = 0;
    var seriesIndex = 0;
    return dv
        .rawData()
        .twoDimData()
        .map(function (resData, index) {
        if (resData[0] === null || resData[1] === null || resData[2] === null) {
            seriesIndex++;
            return null;
        }
        var data = [];
        var emptyBucketsCount = getCountOfEmptyBuckets([
            primaryMeasuresBucketEmpty,
            secondaryMeasuresBucketEmpty,
        ]);
        data = [
            {
                x: !primaryMeasuresBucketEmpty ? common_1.parseValue(resData[0]) : 0,
                y: !secondaryMeasuresBucketEmpty ? common_1.parseValue(resData[1 - emptyBucketsCount]) : 0,
                // we want to allow NaN on z to be able show bubble of default size when Size bucket is empty
                z: parseFloat(resData[2 - emptyBucketsCount]),
                format: common_1.unwrap(last_1.default(measureGroup.items)).format,
            },
        ];
        return {
            name: stackByAttribute ? stackByAttribute.items[index].attributeHeaderItem.name : "",
            color: colorStrategy.getColorByIndex(legendIndex),
            legendIndex: legendIndex++,
            data: data,
            seriesIndex: seriesIndex++,
        };
    })
        .filter(function (serie) { return serie !== null; });
}
exports.getBubbleChartSeries = getBubbleChartSeries;
//# sourceMappingURL=bubbleChartSeries.js.map